const Init = () => {
  const accordionItems = document.querySelectorAll('.o-flipping-media-accordion__item');
  const mediaPane = document.querySelector('.o-flipping-media-accordion__media-pane');

  // Function to handle playing or pausing video
  const handleMediaPlayback = (wrapper, shouldPlay) => {
    const video = wrapper.querySelector('video');
    if (video) {
      if (shouldPlay) {
        // Attempt to play the video, catching any autoplay errors
        video.play().catch(() => {
          // Video was dynamically set and did not load in time to play. Wait for event trigger.
          video.addEventListener('dynamicSourceSet', async () => {
            video.pause();
            video.play();
          })
        });
      } else {
        video.pause();
        video.currentTime = 0; // Optional: reset video to the beginning
      }
    }
  };

  // Set initial state for the first active video
  const initialActiveWrapper = document.querySelector('.o-flipping-media-accordion__media-wrapper--active');
  if (initialActiveWrapper) {
    handleMediaPlayback(initialActiveWrapper, true);
  }

  accordionItems.forEach(item => {
    const header = item.querySelector('.o-flipping-media-accordion__header');
    const targetId = header.getAttribute('data-target');
    const targetMediaWrapper = mediaPane.querySelector(targetId);

    header.addEventListener('click', () => {
      // Check if the clicked item is already active
      const isAlreadyActive = item.classList.contains('o-flipping-media-accordion__item--active');

      if (isAlreadyActive) return; // Optional: do nothing if the active item is clicked again

      // Deactivate all items and media wrappers
      accordionItems.forEach(otherItem => {
        otherItem.classList.remove('o-flipping-media-accordion__item--active');
        otherItem.querySelector('.o-flipping-media-accordion__header').setAttribute('aria-expanded', 'false');
      });

      const currentlyActiveWrapper = mediaPane.querySelector('.o-flipping-media-accordion__media-wrapper--active');
      if (currentlyActiveWrapper) {
        currentlyActiveWrapper.classList.remove('o-flipping-media-accordion__media-wrapper--active');
        handleMediaPlayback(currentlyActiveWrapper, false); // Pause media in the old wrapper
      }

      // Activate the clicked item and its corresponding media wrapper
      item.classList.add('o-flipping-media-accordion__item--active');
      header.setAttribute('aria-expanded', 'true');
      if (targetMediaWrapper) {
        targetMediaWrapper.classList.add('o-flipping-media-accordion__media-wrapper--active');
        handleMediaPlayback(targetMediaWrapper, true); // Play media in the new wrapper
      }
    });

    // Keyboard accessibility for Enter/Space
    header.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); // Prevent page scroll on Space
        header.click();
      }
    });
  });
};

export default Init;
